import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { HomeRoutingModule } from "./home-routing.module";
import { HomePageComponent } from "./home-page/home-page.component";
import { HomeItemComponent } from './home-item/home-item.component';
import { SharedContactFormModule } from "../shared/sharedContactForm.module";
import { HomeinformationComponent } from "../homeinformation/homeinformation.component";
import { SharedAboutUsModule } from "../shared/shared-about-us.module";
import { SharedHomeinformationModule } from "../shared/shared-homeinformation.module";


@NgModule({
  declarations: [HomePageComponent, HomeItemComponent],
  imports: [CommonModule, HomeRoutingModule, SharedContactFormModule, SharedAboutUsModule, SharedHomeinformationModule],
})
export class HomeModule {}
